import { render, staticRenderFns } from "./ManagementSummaryStep.vue?vue&type=template&id=13da6cf5"
import script from "./ManagementSummaryStep.vue?vue&type=script&lang=js"
export * from "./ManagementSummaryStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports